import Sidebar from "./Sidebar";
import MobileNav from "./MobileNav";
import Footer from "./Footer";
import RadioPlayer from "./RadioPlayer";
import EncoreWidget from "./EncoreWidget";
import { useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Bell } from "lucide-react";

const NO_FOOTER_ROUTES = ["/dashboard", "/admin"];

export default function AppShell({ children }) {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const showFooter = !NO_FOOTER_ROUTES.some((r) => pathname.startsWith(r));

  return (
    <div className="min-h-screen text-white font-body" style={{ background: "#0a0a0a" }}>
      <Sidebar />
      <MobileNav />

      {/* Main content */}
      <main className="md:ml-60 pt-14 md:pt-0 pb-16 md:pb-0 min-h-screen flex flex-col">
        {/* Top bar for desktop - notification bell in upper right */}
        <div className="hidden md:flex items-center justify-end px-6 py-3 border-b border-white/5 flex-shrink-0">
          {user ? (
            <button data-testid="notification-bell-desktop" className="relative p-2 text-zinc-400 hover:text-white transition-colors rounded-xl hover:bg-white/5">
              <Bell size={18} />
              <span className="absolute top-1 right-1 w-2 h-2 rounded-full bg-[#00ff77] border border-[#0a0a0a]" />
            </button>
          ) : (
            <div className="w-8" />
          )}
        </div>

        {/* Page content */}
        <div className="flex-1 max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-6">
          {children}
        </div>

        {/* Radio player - above footer */}
        <RadioPlayer />

        {showFooter && <Footer />}
      </main>

      {/* Encore AI Widget - floating */}
      <EncoreWidget />
    </div>
  );
}
